// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2Bv2P","footer":"ModalInfo_footer__33bUx"};